import { ApolloLink, from } from '@apollo/client'

import createErrorLink from './error'
import createHttpLink from './http'

export function createServerLinks(apiURI: string): ApolloLink {
  return from([createErrorLink(), createHttpLink(apiURI)])
}
